import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import { Toaster } from './ui/sonner';

export const Layout = ({ children, showWhatsApp = true }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      {showWhatsApp && <WhatsAppButton />}
      <Toaster position="top-right" />
    </div>
  );
};

export const DashboardLayout = ({ children, sidebar }) => {
  return (
    <div className="min-h-screen bg-slate-900 text-white">
      {sidebar}
      <main className="lg:ml-64 min-h-screen">
        {children}
      </main>
      <Toaster position="top-right" theme="dark" />
    </div>
  );
};

export default Layout;
